import { create as axiosCreate } from './utils/axios';
import { ExperimentRelayError } from './utils/experimentRelayError';
import snakecaseKeys from 'snakecase-keys';
export class ExperimentRelay {
    constructor({ cdpKey, projectId, useProductionEndpoint }) {
        this.axios = axiosCreate(useProductionEndpoint);
        this.cdpKey = cdpKey;
        this.projectId = projectId;
    }
    async getExperiments(params) {
        try {
            return (await this.axios.post('get-experiments', {
                experimentRequests: params.experimentRequests.map(er => ({
                    experimentName: er.experimentName, userToken: this.setUserToken(er.userToken, er.userType),
                })),
                projectId: this.projectId,
                userAttributes: this.setUserAttributes(params.userAttributes),
            })).data;
        }
        catch (error) {
            throw new ExperimentRelayError(error);
        }
    }
    async activateExperiment(params) {
        try {
            return (await this.axios.post('activate-experiment', {
                experimentName: params.experimentName,
                projectId: this.projectId,
                userAttributes: this.setUserAttributes(params.userAttributes),
                userToken: this.setUserToken(params.userToken, params.userType),
                variantName: params.variantName,
            })).data;
        }
        catch (error) {
            throw new ExperimentRelayError(error);
        }
    }
    async getAndActivateExperiment(params) {
        try {
            return (await this.axios.post('get-activate-experiment', {
                experimentName: params.experimentName,
                projectId: this.projectId,
                userAttributes: this.setUserAttributes(params.userAttributes),
                userToken: this.setUserToken(params.userToken, params.userType),
            })).data;
        }
        catch (error) {
            throw new ExperimentRelayError(error);
        }
    }
    async trackEvent(params) {
        if (!this.cdpKey) {
            throw new ExperimentRelayError(new Error('cdpKey required for /track-event endpoint'));
        }
        try {
            return (await this.axios.post('track-event', {
                cdpKey: this.cdpKey,
                eventName: params.eventName,
                projectId: this.projectId,
                userAttributes: this.setUserAttributes(params.userAttributes),
                userToken: this.setUserToken(params.userToken, params.userType),
            })).data;
        }
        catch (error) {
            throw new ExperimentRelayError(error);
        }
    }
    setUserAttributes(attributes) {
        if (!attributes) {
            return;
        }
        const userAttributes = [];
        for (const [key, value] of Object.entries(snakecaseKeys(attributes))) {
            if (typeof value === 'number') {
                userAttributes.push({
                    name: key,
                    intValue: value,
                });
            }
            else if (typeof value === 'boolean') {
                userAttributes.push({
                    name: key,
                    boolValue: value,
                });
            }
            else {
                userAttributes.push({
                    name: key,
                    stringValue: String(value),
                });
            }
        }
        return { userAttributes };
    }
    setUserToken(userToken, userType) {
        return {
            token: String(userToken),
            type: userType === 'AUTHENTICATED' ? 'MERCHANT' : 'DEVICE_ID',
        };
    }
}
